<template lang="pug">
  sw-select(
    :customClasses='customClasses'
    :dropdownClasses='dropdownClasses'
    v-bind="{...$props, ...$attrs}"
    v-on="$listeners"
  )
    template(v-slot:query-input="{ query, handleQuery, close }")
      .hidden.justify-center.border-b.border-gray-200(class='md:flex' v-if='filterable')
        input.relative.m-2.p-2.w-full.text-left.appearance-none.rounded-sm.text-sm(
          class='focus:outline-none focus:border-green-900 border'
          :value='query'
          @input='handleQuery($event.target.value)'
          @keydown.esc='close()'
        )
    template(v-slot:default="{ isSelectedItem, item }")
      div.text-gray-900.select-none.relative.pl-3.py-1.pr-9.cursor-pointer(class='hover:bg-green-900 hover:text-white first:pt-0 last:pb-0')
        .flex.items-center
          img.flex-shrink-0.h-8.w-8.rounded-full(
            v-show='item.image'
            :src="item.image"
            :class="{'border-green-900 border-2': isSelectedItem(item.value)}"
          )
          span.ml-3.block.font-medium(
            class='md:text-lg'
            :class="{'font-bold': isSelectedItem(item.value)}"
          ) {{ item.label || item.value }}
        span.absolute.inset-y-0.right-0.flex.items-center.pr-4(v-if='isSelectedItem(item.value)')
          sw-icon(name='check' size='h-8 w-8')
</template>

<script>
import SwSelect from '../generic/SwSelect';

export default {
  name: 'ProfilingSelect',
  components: { SwSelect },
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    error: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    filterable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    mainClasses () {
      return 'text-gray-700 border md:border-2 rounded font-medium block w-full pl-3 pr-8 py-4 leading-tight focus:outline-none md:p-5 focus:outline-none focus:border-green-900 placeholder-gray-250';
    },
    statusClasses () {
      if (this.error) return 'border-red-500 bg-red-100 hover:bg-white hover:border-red-500 hover:text-red-500 focus:border-red-500';
      if (this.disabled) return 'cursor-not-allowed opacity-100 bg-white border-gray-300';
      if (this.value) return 'bg-white hover:bg-white hover:border-green-900 focus:border-green-900 border-green-900 bg-green-150 text-green-900';
      return 'bg-white hover:border-green-900 focus:border-green-900 border-gray-300';
    },
    customClasses () {
      return `${this.mainClasses} ${this.statusClasses}`;
    },
    dropdownClasses () {
      return 'w-full z-5 bg-gray-100 shadow-lg rounded border border-green-900 md:my-2';
    },
  },
};
</script>
